import { useMemo, useState } from "react";
import { geoNaturalEarth1, geoPath } from "d3-geo";
import { feature } from "topojson-client";
import world from "world-atlas/countries-110m.json";
import countries from "i18n-iso-countries";
import en from "i18n-iso-countries/langs/en.json";

countries.registerLocale(en);
const shapes = feature(world, world.objects.countries).features.filter((f) => f.id !== "010");
const projection = geoNaturalEarth1().fitSize([960, 470], { type: "FeatureCollection", features: shapes });
const path = geoPath(projection);

export const ReaderMap = ({ data }) => {
  const [hover, setHover] = useState(null);
  const byNumeric = useMemo(
    () => Object.fromEntries(data.map((c) => [countries.alpha2ToNumeric(c.code), c])),
    [data]
  );
  const max = Math.max(1, ...data.map((c) => c.visits));
  const total = data.reduce((n, c) => n + c.visits, 0);
  const fill = (v) => (v ? `rgba(139, 0, 0, ${0.18 + 0.82 * Math.sqrt(v / max)})` : "#E9E9E6");

  return (
    <div className="bg-white border border-[var(--rule)] p-6" data-testid="visits-reader-map">
      <div className="flex items-baseline justify-between">
        <p className="meta">Where your readers are — last 30 days</p>
        <p className="font-ui text-sm text-[var(--ink-2)] min-h-[20px]" data-testid="reader-map-hover">
          {hover ? `${countries.getName(hover.code, "en") || hover.code}: ${hover.visits} ${hover.visits === 1 ? "visit" : "visits"}` : ""}
        </p>
      </div>
      <div className="mt-4 grid gap-8 lg:grid-cols-[1fr_260px]">
        <svg viewBox="0 0 960 470" className="w-full h-auto" role="img" aria-label="World map of readers">
          {shapes.map((f) => {
            const c = byNumeric[f.id];
            return (
              <path key={f.id + (f.properties?.name || "")} d={path(f)} fill={fill(c?.visits)} stroke="#FFFFFF" strokeWidth={0.5}
                className="transition-opacity duration-150 hover:opacity-80" onMouseEnter={() => c && setHover(c)} onMouseLeave={() => setHover(null)} />
            );
          })}
        </svg>
        <div data-testid="reader-map-countries">
          {data.length === 0 && <p className="italic text-[var(--ink-3)]">No visits yet.</p>}
          {data.slice(0, 10).map((c) => (
            <div key={c.code} className="flex justify-between py-2 border-b border-[var(--rule)] font-ui text-sm" data-testid={`reader-country-${c.code}`}>
              <span>{countries.getName(c.code, "en") || c.code}</span>
              <span className="tabular-nums"><span className="font-semibold">{c.visits}</span> <span className="text-[var(--ink-3)] text-xs">{Math.round((c.visits / total) * 100)}%</span></span>
            </div>
          ))}
        </div>
      </div>
      <p className="mt-4 font-ui text-xs text-[var(--ink-3)]">Country is estimated from each visit's network address, which is never stored. IP geolocation by DB-IP.</p>
    </div>
  );
};
